import { Navigate } from 'react-router-dom';

import MenuShell from '../components/MenuShell';
import { useInstructorCourseId } from '../features/instructor/useInstructorCourseId';

/**
 * Target of the instructor's "Challenge" nav link when no challenge is running: forwards to the
 * leaderboard of the selected class (or the most recently active class, then the first owned
 * class) so they can start one from there.
 */
function InstructorChallengePage() {
  const { courseId, errorMessage } = useInstructorCourseId();

  if (courseId) {
    return <Navigate to={`/courses/${courseId}/leaderboard`} replace />;
  }

  return (
    <>
      <MenuShell courseId="" />
      <main style={{ maxWidth: 960, margin: '3rem auto', padding: '0 1rem' }}>
        {errorMessage && <p role="alert">{errorMessage}</p>}
      </main>
    </>
  );
}

export default InstructorChallengePage;
